export class ProjectUpdates {
    SNO: number;
    Description: string;
    DocumentPath: string;
}